import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AdminHeader, Card, Empty } from "@/components/admin/ui";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/admin/customers").then(({ data }) => setCustomers(data.customers)); }, []);
  return (
    <div>
      <AdminHeader title="Customers" subtitle={`${customers.length} customers`} />
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Phone</th><th className="p-3">Orders</th><th className="p-3">Joined</th></tr></thead>
            <tbody className="divide-y divide-slate-100">
              {customers.map((c) => (
                <tr key={c.id} className="hover:bg-slate-50 cursor-pointer" onClick={() => navigate(`/admin/customers/${c.id}`)} data-testid={`customer-${c.id}`}>
                  <td className="p-3 font-medium text-slate-900">{c.name}</td>
                  <td className="p-3 text-slate-600">{c.email}</td>
                  <td className="p-3 font-mono text-xs">{c.phone || "—"}</td>
                  <td className="p-3 font-mono">{c.orderCount}</td>
                  <td className="p-3 text-xs text-slate-500">{new Date(c.createdAt).toLocaleDateString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {customers.length === 0 && <Empty />}
        </div>
      </Card>
    </div>
  );
}
